import {Component} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

import {STATE} from './manage-access-criterion-modal.interface';

import {Destroyable} from '../../../destroyable.component';
import {AnyData} from '../../../shared/api';
import {TreeNode} from '../../../shared/ui';
import {EmpPopulationCriterion, RepPopulationCriterion} from '../user-rights.interfaces';

@Component({
  template: '',
  styleUrls: ['./manage-access-criterion-modal.component.scss'],
})
export class ManageAccessCriterionModalComponent extends Destroyable {
  public currentState: STATE | '' = STATE.INITIAL_STATE;
  public criterionToBeUpdated = 0;
  public criterionToBeDeleted = 0;
  public showConfirmDeletionMessage = false;

  constructor() {
    super();
  }

  public get isContentLoading(): boolean {
    return this.currentState === STATE.TABLE_LOADING;
  }

  public get isContentLoaded(): boolean {
    return this.currentState === STATE.TABLE_LOADED;
  }

  public get isAddCriterionActive(): boolean {
    return (
      this.currentState === STATE.CREATE_NEW_CRITERION
      || this.currentState === STATE.CREATE_NEW_CRITERION_IN_PROGRESS
    );
  }

  public get isUpdateCriterionActive(): boolean {
    return this.currentState === STATE.UPDATE_CRITERION
      || this.currentState === STATE.UPDATE_CRITERION_IN_PROGRESS;
  }

  public get isDeleteCriterionActive(): boolean {
    return this.currentState === STATE.DELETE_CRITERION
      || this.currentState === STATE.DELETE_CRITERION_IN_PROGRESS;
  }

  public get isOperationInProgress(): boolean {
    return (
      this.currentState === STATE.CREATE_NEW_CRITERION_IN_PROGRESS ||
      this.currentState === STATE.UPDATE_CRITERION_IN_PROGRESS ||
      this.currentState === STATE.DELETE_CRITERION_IN_PROGRESS
    );
  }

  public get isAddOrUpdateActive(): boolean {
    return this.isAddCriterionActive || this.isUpdateCriterionActive;
  }

  public trackByCriterionId(index: number, criterion: EmpPopulationCriterion | RepPopulationCriterion): number {
    return criterion.id;
  }

  public responseCallback(response: any, lookupMap: Map<any, any>): TreeNode<any>[] {
    const list: any = response;
    const tree = [];

    list.forEach((item: AnyData) => lookupMap.set(item.id, {
      text: item.name,
      value: item.id < 0 ? -item.id : item.id,
      data: item,
      selectable: item.userSelectable !== false,
      visible: true,
      children: []
    }));

    for (const item of Array.from(lookupMap.values())) {
      const parent: TreeNode<AnyData> = lookupMap.get(item.data.parentId);
      if (parent !== undefined) {
        parent.children.push(item);
      } else {
        tree.push(item);
      }
    }
    return tree;
  }

  public hideAddOrUpdateForm(form: UntypedFormGroup): void {
    this.hideUpdateForm();
    form.reset();
    this.currentState = STATE.TABLE_LOADED;
  }

  public hideUpdateForm(): void {
    this.criterionToBeUpdated = 0;
  }

  public discardDeleteCriterion(): void {
    this.showConfirmDeletionMessage = false;
    this.criterionToBeDeleted = 0;
    this.currentState = STATE.TABLE_LOADED;
  }

  public deleteCriterion(id: number): void {
    this.showConfirmDeletionMessage = true;
    this.criterionToBeDeleted = id;
    this.currentState = STATE.DELETE_CRITERION;
  }

  public showUpdateCriterionFormFields(form: UntypedFormGroup): void {
    this.hideAddOrUpdateForm(form);
    this.currentState = STATE.UPDATE_CRITERION;
  }
}
